import {ChangedStructuredTableUuids} from 'notebook/mediocre/core-ui/structured-tables/convertStructuredTableForPaste';
import {
  StructuredTableMapping,
  StructuredTableColumnMapping,
} from 'notebook/structured-tables/structured-table-mappings/StructuredTableMappingConstants';

/** Convert a set of StructuredTableMappings from one set of table and column uuids to another. */
export default function updateStructuredTableMappingUuids(
  structuredTableMappings: Array<StructuredTableMapping>,
  changedStructuredTableUuids: ChangedStructuredTableUuids
): Array<StructuredTableMapping> {
  const {oldToNewStructuredTableUuids, oldToNewStructuredTableColumnUuids} = changedStructuredTableUuids;
  return (
    structuredTableMappings
      .map((tableMapping) => ({
        ...tableMapping,
        sourceTableProvenanceUuid: oldToNewStructuredTableUuids[tableMapping.sourceTableProvenanceUuid],
        destinationTableProvenanceUuid:
          oldToNewStructuredTableUuids[tableMapping.destinationTableProvenanceUuid],
        structuredTableColumnMappings: updateStructuredTableColumnMappingUuids(
          tableMapping.structuredTableColumnMappings,
          oldToNewStructuredTableColumnUuids[tableMapping.sourceTableProvenanceUuid],
          oldToNewStructuredTableColumnUuids[tableMapping.destinationTableProvenanceUuid]
        ),
      }))
      // filter out any mappings that we can't find a source or destination table for
      .filter((tableMapping): tableMapping is StructuredTableMapping =>
        Boolean(tableMapping.sourceTableProvenanceUuid && tableMapping.destinationTableProvenanceUuid)
      )
  );
}

function updateStructuredTableColumnMappingUuids(
  structuredTableColumnMappings: Array<StructuredTableColumnMapping>,
  sourceOldToNewStructuredTableColumnUuids: ChangedStructuredTableUuids['oldToNewStructuredTableColumnUuids'][string],
  destinationOldToNewStructuredTableColumnUuids: ChangedStructuredTableUuids['oldToNewStructuredTableColumnUuids'][string]
): Array<StructuredTableColumnMapping> {
  return (
    structuredTableColumnMappings
      .map((columnMapping) => ({
        ...columnMapping,
        sourceTableColumnProvenanceUuid:
          sourceOldToNewStructuredTableColumnUuids?.[columnMapping.sourceTableColumnProvenanceUuid],
        destinationTableColumnProvenanceUuid:
          destinationOldToNewStructuredTableColumnUuids?.[columnMapping.destinationTableColumnProvenanceUuid],
      }))
      // filter out any column mappings that we can't find a source or destination column for
      .filter((columnMapping): columnMapping is StructuredTableColumnMapping =>
        Boolean(
          columnMapping.sourceTableColumnProvenanceUuid && columnMapping.destinationTableColumnProvenanceUuid
        )
      )
  );
}
